/* eslint-disable @typescript-eslint/no-unused-vars */
import { useState } from 'react';
import { Environment } from '../../../environment';
import axios, { AxiosError } from 'axios';
import { Api } from '../axiosApi';
export interface IListagemPlanoDeContas {
  id: string;
  label: string;
}
interface GetAllListPlanoDeContas {
  idplanoconta: string;
  descricao: string;
  grupo: string;
}
export interface IDetalhePlanoDeContas { 
  idpai: string;
  id: string;
  label: string;
}
interface CreatePlanoDeContas {
  idpai: string;
  idplanoconta: string;
  descricao: string;
}
type TComTotalCount = {
  data: IListagemPlanoDeContas[];
  totalCount: number;
}
type TComTotalCountGetAllList = {
  data: GetAllListPlanoDeContas[];
  totalCount: number;
}

interface ErrorResponse {
  errors: {
    default: string;
  };
}

const getAll = async (): Promise<TComTotalCount | Error> => {
  try {
    const urlRelativa = '/planoconta';
    const { data, headers } = await Api.get(urlRelativa);
    if (data) {
      return {
        data,
        totalCount: Number(headers['x-total-count'] || Environment.LIMITE_DE_LINHAS),
      };
    }
    return new Error('Erro ao listar os registros.');
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ErrorResponse>;
      if (axiosError.response) {
        const errorMessage = axiosError.response.data.errors?.default || 'Erro desconhecido';
        return new Error(errorMessage);
      } else if (axiosError.request) {
        return new Error('Nenhuma resposta do servidor');
      } else {
        return new Error(axiosError.message);
      }
    } else {
      return new Error('Erro inesperado');
    }
  }
};
const getAlllist = async (filter = '', id=''): Promise<TComTotalCountGetAllList | Error> => {
  try {
    const urlRelativa: string = id === '' ? `/planocontalist?limit=${Environment.LIMITE_DE_LINHAS}&filter=${filter}` : `/planoconta/${id}` ;
    const { data, headers } = await Api.get(urlRelativa);
    if (data) {
      return {
        data,
        totalCount: Number(headers['x-total-count'] || Environment.LIMITE_DE_LINHAS),
      };
    }
    return new Error('Erro ao listar os registros.');
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ErrorResponse>;
      if (axiosError.response) {
        const errorMessage = axiosError.response.data.errors?.default || 'Erro desconhecido';
        return new Error(errorMessage);
      } else if (axiosError.request) {
        return new Error('Nenhuma resposta do servidor');
      } else {
        return new Error(axiosError.message);
      }
    } else {
      return new Error('Erro inesperado');
    }
  }
};
const create = async (dados: CreatePlanoDeContas): Promise<string | Error> => {
  try {
    if(dados.idpai === 'null'){
      const { idpai, ...dadosIDetalheSaida } = dados;
      const { data } = await Api.post<CreatePlanoDeContas>('/planoconta', dadosIDetalheSaida);
      if (Object.keys(data).length === 0) {
        return 'ok';
      }
      return new Error('Erro ao criar o registro.');
    }else{
      const { data } = await Api.post<CreatePlanoDeContas>('/planoconta', dados);
      if (Object.keys(data).length === 0) {
        return 'ok';
      }
      return new Error('Erro ao criar o registro.');
    }
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ErrorResponse>;
      if (axiosError.response) {
        const errorMessage = axiosError.response.data.errors?.default || 'Erro desconhecido';
        return new Error(errorMessage);
      } else if (axiosError.request) {
        return new Error('Nenhuma resposta do servidor');
      } else {
        return new Error(axiosError.message);
      }
    } else {
      return new Error('Erro inesperado');
    }
  }
};
const updateById = async (id: string, descricao: string): Promise<void | Error> => {
  try {
    if(id != 'null'){
      await Api.put(`/planoconta/${id}`, {descricao: descricao});
    }
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ErrorResponse>;
      if (axiosError.response) {
        const errorMessage = axiosError.response.data.errors?.default || 'Erro desconhecido';
        return new Error(errorMessage);
      } else if (axiosError.request) {
        return new Error('Nenhuma resposta do servidor');
      } else {
        return new Error(axiosError.message);
      }
    } else {
      return new Error('Erro inesperado');
    }
  }
};
export const PlanoDeContasService = {
  getAll,
  getAlllist,
  create,
  updateById,
};